import React, { useEffect, useState, useRef } from "react";

// local import
import "./style.scss";
import Sometext from "../../utils/text.js";
import me from "../../assets/me.jpeg";
import shell1 from "../../assets/shell.png";
import html from "../../assets/html.png";
import css from "../../assets/css.png";
import js from "../../assets/js.png";
import react from "../../assets/react.png";
import node from "../../assets/node.png";
import sql from "../../assets/sql.png";
import ps from "../../assets/ps.png";
import figma from "../../assets/figma.png";
import git from "../../assets/git.png";
import angular from "../../assets/angular.png";
import mongo from "../../assets/mongo.png";
import sass from "../../assets/sass.png";

const About = (props) => {
  const [isVisible, setVisible] = useState(false);

  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setVisible(entry.isIntersecting));
    });
    observer.observe(domRef.current);
  }, []);

  return (
    <div
      className={`fade-in-section ${isVisible ? "is-visible" : ""}`}
      ref={domRef}
    >
      <div className="about">
        <div className="meDiv">
          <img src={me} alt="I" className="me" />
        </div>

        <div className="textWrapper">
          <h1>Who's this dude?</h1>
          <p className="text">{Sometext[0].text1}</p>
          <p className="text">{Sometext[0].text2}</p>
          <p className="text">{Sometext[0].text3}</p>
          <p className="text">{Sometext[0].text4}</p>
          <p className="text">{Sometext[0].text5}</p>
          <h3 className="textSet">My actual skill set:</h3>
        </div>
      </div>


      {[
        [
          { src: shell1,    alt: "Shell" },
          { src: html,      alt: "HTML" },
          { src: css,       alt: "CSS" },
          { src: sass,      alt: "SASS" },
          { src: js,        alt: "JavaScript" },
          { src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg", alt: "TypeScript" },
          { src: react,     alt: "React" },
          { src: angular,   alt: "Angular" },
        ],
        [
          { src: node,      alt: "Node.js" },
          { src: sql,       alt: "SQL" },
          { src: mongo,     alt: "MongoDB" },
          { src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg",        alt: "C" },
          { src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg", alt: "C++" },
          { src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg", alt: "Docker" },
          { src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg", alt: "AWS" },
          { src: git,       alt: "Git" },
          { src: figma,     alt: "Figma" },
          { src: ps,        alt: "Photoshop" },
        ],
      ].map((row, i) => (
        <div className="iconsDisplay" key={i}>
          {row.map(({ src, alt }) => (
            <div className="skill-icon" key={alt}>
              <img src={src} alt={alt} className="icons" />
              <span className="skill-label">{alt}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default About;
